<template>
    <div class="list--view">
        <div class="single--list-view single--list-view-roles">
            <vs-select
                class="selectExample"
                v-model="selectTypeRoles"
                @input="typologySelected"

            >
                <vs-select-item
                    :is-selected.sync="item.isSelected"
                    :key="index"
                    :value="item.value"
                    :text="item.label"
                    v-for="(item,index) in optionsTypeRoles" />
            </vs-select>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                  selectTypeRoles: /typology=([^&]+)/.exec(location.href) == null ? "" : /typology=([^&]+)/.exec(location.href)[1],

                optionsTypeRoles:[],

            }
        },
        methods: {
            typologySelected(selectedOption, id) {

                if(selectedOption===''){
                    location.href = "/organizational-units";
                }
                else {
                    location.href = app.__vue__.addParam('typology', selectedOption);
                }
            },

            loadTypologies(){

                axios
                    .get("/getOrgUnit")
                    .then(response => {
                        this.datas = response.data;
                        this.optionsTypeRoles=this.datas;
                    });
            }
        },


        mounted(){
            this.loadTypologies()

        }
    }
</script>
